import React from 'react';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

import IconButton from './IconButton';
import Toolbar, { ToolbarProps } from './Toolbar';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    gap: {
      flex: 1,
    },
    leftButton: {
      marginLeft: -1 * unit * 2,
    },
    rightButton: {
      marginRight: -1 * unit * 2,
    },
  });

export interface ToolbarNavigationProps extends WithStyles<typeof styles>, Omit<ToolbarProps, 'classes'> {
  onBack?: () => void;
  onClose?: () => void;
}

const ToolbarNavigation: React.FC<ToolbarNavigationProps> = ({ classes, children, onBack, onClose, ...rest }) => (
  <Toolbar {...rest}>
    {onBack && (
      <IconButton className={classes.leftButton} onClick={onBack}>
        <KeyboardArrowLeftIcon fontSize={rest.variant === 'dense' ? 'small' : undefined} />
      </IconButton>
    )}
    {children}
    {onClose && (
      <>
        <div className={classes.gap} />
        <IconButton className={classes.rightButton} onClick={onClose}>
          <CloseIcon fontSize={rest.variant === 'dense' ? 'small' : undefined} />
        </IconButton>
      </>
    )}
  </Toolbar>
);

export default withStyles(styles)(ToolbarNavigation);
